import { Fragment } from 'react'
import { NextSeo } from 'next-seo'

import NavigationBar from '@/components/NavigationBar'
import Footer from '@/components/Footer'

import Contact from '@/features/landing/templates/Contact'

import PageHeader from '@/features/blogs/templates/BlogList/PageHeader'
import Pagination from '@/features/blogs/templates/BlogList/Pagination'
import BlogListTemplate from '@/features/blogs/templates/BlogList/BlogList'

import { QueryParamsContextProvider } from '@/lib/context/queryParams'

import { BlogListItem } from '@/features/blogs/types/blog'

export interface BlogListProps {
  blogs: BlogListItem[] | null
  currentPage?: number
  totalPage?: number
}

function BlogList({
  blogs,
  currentPage = 1,
  totalPage = 1,
}: BlogListProps): React.ReactElement {
  return (
    <Fragment>
      <NextSeo title="Blogs" />
      <NavigationBar />
      <QueryParamsContextProvider shallowRouteChange={false}>
        <PageHeader />
        {blogs && <BlogListTemplate blogs={blogs} />}
        <Pagination currentPage={currentPage} totalPage={totalPage} />
        <Contact />
        <Footer />
      </QueryParamsContextProvider>
    </Fragment>
  )
}

export default BlogList
